import { AGREEMENT_STATE } from "astrid-functions/src/functions/scrive/agreement/constants";

import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { boolean, enumValues, file, nullable, string, timestamp } from "../../../types/_types";

import { OrganizationRef } from "../../organizations/types/OrganizationRef";
import { Party } from "../../organizations/types/Party";
import { ProductionRef } from "../../productions/types/Production";
import { UserRef } from "../../users/types/User";

import agreementStatuses from "../constants/agreementStatuses";

import { AgreementTemplate, AgreementTemplateRef } from "./AgreementTemplate";
import { termination } from "./_types";

export const Agreement = AgreementTemplate.extend({
	activeFrom: timestamp(),
	expires: timestamp(),
	firstSignee: nullable(UserRef),
	initiatedSigning: boolean(false),
	production: nullable(ProductionRef),
	publisher: nullable(OrganizationRef),
	scriveDocumentId: nullable(string()),
	secondParty: Party,
	firstParty: Party,
	secondSignee: UserRef,
	signedAgreementFile: nullable(file()),
	state: enumValues(AGREEMENT_STATE),
	status: enumValues(agreementStatuses),
	template: nullable(AgreementTemplateRef),
	termination: termination(),
}).merge(FirestoreLifecycle);
